<template>
  <div id="app">
    <chat />
    <!-- 公共导航栏 -->
    <nav-bar />

    <!-- 页面内容区域（路由切换） -->
    <div class="content">
      <router-view :key="$route.fullPath" />
    </div>
    <foot-bar v-if="!['/login', '/reset', '/reg'].some(item => $route.path.includes(item))" />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import FootBar from '@/components/FootBar.vue'
import chat from './components/chat.vue';

export default {
  name: 'Home',
  components: {
    NavBar,
    FootBar,
    chat
  }
}
</script>
<style lang="less">
* {
  padding: 0;
  margin: 0;
  outline: none;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.5;
}

img {
  border: none;
  outline: none;
  margin: 0;
  padding: 0;
  /* 保持比例不拉伸 */
  max-width: 100%;
  height: auto;
  /* 去掉图片底部默认空白缝隙 */
  vertical-align: middle;
}

body {
  background-color: #000;
}

li {
  list-style: none;
  /* 全局去掉 */
}

html,
body,
#app {
  width: 100%;
  /* 关键：让它们的宽度跟随内容，而不是视口 */
  min-width: max-content;
  margin: 0;
  padding: 0;
}
</style>
